export const sequence = {
    sequence_empty_list: 'There is no questionnaires available for this time period.',
};
